export default __webpack_public_path__ + "static/media/logo02.ddce9c57.svg";